
import Vue from 'vue'
import { abi } from 'thor-devkit'

interface TabItem {
    title: string
    sym: string
    loader: (offset: number, pageSize: number) => Promise<TransferItemData[]>
}

export default Vue.extend({
    data: () => {
        return {
            address: '',
            tab: 0
        }
    },
    computed: {
        tabs(): TabItem[] {
            return [{
                title: 'VET',
                sym: 'VET',
                loader: async (offset, pageSize) => {
                    const items = await this.$connex.thor.filter('transfer', [{ sender: this.address }, { recipient: this.address }])
                        .order('desc')
                        .apply(offset, pageSize)
                    return items.map(i => ({
                        from: i.sender,
                        to: i.recipient,
                        amount: i.amount,
                        timestamp: i.meta!.blockTimestamp,
                        owner: this.address,
                        txid: i.meta!.txID,
                    }))
                }
            }, {
                title: 'VTHO',
                sym: 'VTHO',
                loader: async (offset, pageSize) => {
                    const items = await this.$connex.thor
                        .account('0x0000000000000000000000000000456E65726779')
                        .event(vip180TransferEventABI)
                        .filter([{ from: this.address }, { to: this.address }])
                        .order('desc')
                        .apply(offset, pageSize)

                    return items.map(i => ({
                        from: i.decoded!.from,
                        to: i.decoded!.to,
                        amount: i.decoded!.value,
                        timestamp: i.meta!.blockTimestamp,
                        owner: this.address,
                        txid: i.meta!.txID,
                    }))
                }
            }]
        }
    },
    created() {
        this.address = this.$route.params.address.toLowerCase()
    }
})

const vip180TransferEventABI = {
    anonymous: false,
    inputs: [
        {
            indexed: true,
            name: 'from',
            type: 'address'
        },
        {
            indexed: true,
            name: 'to',
            type: 'address'
        },
        {
            indexed: false,
            name: 'value',
            type: 'uint256'
        }
    ],
    name: 'Transfer',
    type: 'event'
}
